import { useCallback } from "react";

import { FORM_TYPE } from "@/constants/global";
import { useAppSelector } from "@/redux/hook";

export const useCheckSubscription = (): ((type: FORM_TYPE) => boolean) => {
  const { licenseTenant } = useAppSelector((state) => state.licenseTenant);

  return useCallback(
    (type: FORM_TYPE): boolean => {
      switch (type) {
        case FORM_TYPE.FIXED_FORM:
          return licenseTenant?.enableFixedFormPipeline ?? false;
        case FORM_TYPE.LLM_IE:
          return licenseTenant?.enableLlmIePipeline ?? false;
        case FORM_TYPE.MANUAL_CLASSIFICATION:
          return licenseTenant?.enableManualClassificationPipeline ?? false;
        case FORM_TYPE.AUTO_CLASSIFICATION:
          return licenseTenant?.enableAutoClassificationPipeline ?? false;
        default:
          return false;
      }
    },
    [
      licenseTenant?.enableFixedFormPipeline,
      licenseTenant?.enableLlmIePipeline,
      licenseTenant?.enableManualClassificationPipeline,
      licenseTenant?.enableAutoClassificationPipeline,
    ]
  );
};
